import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import Icon from "../Icon";
import "./SocialSharing.scss";
export var SocialSharing = function SocialSharing(a) {
  _extends({}, a);

  return /*#__PURE__*/React.createElement("div", {
    className: "socialsharing"
  }, /*#__PURE__*/React.createElement(Icon, {
    tag: "a",
    icon: "email",
    href: "mailto:?subject=Check out this property/lot!&body=" + window.location.href,
    className: "email"
  }), /*#__PURE__*/React.createElement(Icon, {
    tag: "a",
    icon: "facebook",
    href: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href,
    className: "facebook",
    external: !0
  }));
};
export default SocialSharing;